(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anti-again-cream"] && !Shopify.designMode) return;
  try {
    
(function aacInit(){
var root=document.getElementById('aac-page');if(!root)return setTimeout(aacInit,50);

var tiTrack=root.querySelector('#aac-testi-slider .aac-testi-track');
var tiDots=root.querySelector('#aac-testi-dots');
var tiNav=root.querySelector('.aac-testi-nav');
var tiCards=tiTrack?tiTrack.querySelectorAll('.aac-testi-card'):[];

if(tiDots&&tiCards.length){
var h='';
for(var i=0;i<tiCards.length;i++){h+='<button class="aac-testi-dot'+(i===0?' active':'')+'" data-idx="'+i+'"></button>';}
tiDots.innerHTML=h;
var tiCur=0;
function setTiDot(n){tiCur=n;tiDots.querySelectorAll('button').forEach(function(d,k){d.classList.toggle('active',k===n)});}
function tiScrollTo(n){if(tiCards[n]){tiTrack.scrollLeft=tiCards[n].offsetLeft-tiTrack.offsetLeft}setTiDot(n);}
tiDots.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;tiScrollTo(parseInt(b.getAttribute('data-idx')));});
if(tiNav){tiNav.querySelectorAll('.aac-arrow').forEach(function(a){a.addEventListener('click',function(){var d=this.getAttribute('data-dir');var next=Math.max(0,Math.min(tiCards.length-1,tiCur+(d==='prev'?-1:1)));tiScrollTo(next);});});}
tiTrack.addEventListener('scroll',function(){var left=tiTrack.scrollLeft,mid=left+tiTrack.clientWidth*.5,best=0,bestD=Infinity;for(var k=0;k<tiCards.length;k++){var delta=Math.abs(tiCards[k].offsetLeft-mid);if(delta<bestD){bestD=delta;best=k;}}setTiDot(best);},{passive:true});
}

var viTrack=root.querySelector('#aac-video-slider .aac-video-track');
var viDots=root.querySelector('#aac-video-dots');
var viOuter=root.querySelector('#aac-video-slider');
var viCards=viTrack?viTrack.querySelectorAll('.aac-video-card'):[];
if(viDots&&viCards.length){
var vh='';
for(var j=0;j<viCards.length;j++){vh+='<button class="aac-video-dot'+(j===0?' active':'')+'" data-idx="'+j+'"></button>';}
viDots.innerHTML=vh;
var viCur=0;
viTrack.scrollLeft=0;
var viDotsBtns=viDots.querySelectorAll('button');
function setViDot(n){viCur=n;viDotsBtns.forEach(function(d,k){d.classList.toggle('active',k===n)});}
function viScrollTo(n){viCur=n;if(viCards[n]){viTrack.scrollLeft=viCards[n].offsetLeft-viTrack.offsetLeft}setViDot(n);}
viDots.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;viScrollTo(parseInt(b.getAttribute('data-idx')));});
viOuter.querySelectorAll('.aac-arrow--abs').forEach(function(a){a.addEventListener('click',function(){var d=this.getAttribute('data-dir');var next=Math.max(0,Math.min(viCards.length-1,viCur+(d==='prev'?-1:1)));viScrollTo(next);});});
var viSt;
viTrack.addEventListener('scroll',function(){clearTimeout(viSt);viSt=setTimeout(function(){var left=viTrack.scrollLeft,mid=left+viTrack.clientWidth*.25,best=0,bestD=Infinity;for(var k=0;k<viCards.length;k++){var delta=Math.abs(viCards[k].offsetLeft-mid);if(delta<bestD){bestD=delta;best=k;}}viCur=best;setViDot(best);},200);},{passive:true});

var viAutoObs=new IntersectionObserver(function(e){
e.forEach(function(en){
var card=en.target;var v=card.querySelector('video');if(!v)return;
if(en.isIntersecting&&en.intersectionRatio>0.5){v.play().catch(function(){});card.classList.add('playing')}
else{v.pause();card.classList.remove('playing')}
});
},{threshold:[0,.3,.5,.7,1]});
viCards.forEach(function(c){viAutoObs.observe(c);});
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ave79-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
var bar=document.getElementById('av79-sticky');
if(!bar||bar.dataset.ready==='true')return;
bar.dataset.ready='true';

var DURATION=900;
var h=bar.querySelector('[data-av79-h]');
var m=bar.querySelector('[data-av79-m]');
var s=bar.querySelector('[data-av79-s]');
var key='av79_full_offer_'+location.pathname;

function readExpiry(){
try{return parseInt(localStorage.getItem(key),10)||0}catch(e){return 0}
}
function saveExpiry(v){
try{localStorage.setItem(key,String(v))}catch(e){}
}
function pad(v){return String(v).padStart(2,'0')}

var expiry=readExpiry();
if(!expiry||expiry<=Date.now()){
expiry=Date.now()+DURATION*1000;
saveExpiry(expiry);
}

function render(){
var left=Math.max(0,Math.floor((expiry-Date.now())/1000));
if(left<=0){expiry=Date.now()+DURATION*1000;saveExpiry(expiry);left=DURATION}
if(h)h.textContent=pad(Math.floor(left/3600));
if(m)m.textContent=pad(Math.floor((left%3600)/60));
if(s)s.textContent=pad(left%60);
}

render();
var timer=setInterval(render,1000);

document.addEventListener('shopify:section:unload',function(event){
if(event.target&&event.target.contains&&event.target.contains(bar)){clearInterval(timer)}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezel-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pbz .bfq-it').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
  function setupDots(track,dots,actCls){
    if(!track||!dots)return;
    var slides=track.children,nSlides=slides.length,lastIdx=0;
    dots.innerHTML='';
    for(var i=0;i<nSlides;i++){
      var s=document.createElement('span');
      if(i===0)s.className=actCls;
      (function(idx){s.addEventListener('click',function(){track.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'})})})(i);
      dots.appendChild(s);
    }
    track.addEventListener('scroll',function(){
      var left=track.scrollLeft,mid=left+track.clientWidth/2;
      var bestIdx=0,bestDist=Infinity;
      for(var i=0;i<nSlides;i++){var d=Math.abs(slides[i].offsetLeft+slides[i].offsetWidth/2-mid);if(d<bestDist){bestDist=d;bestIdx=i}}
      if(bestIdx===lastIdx)return;
      dots.children[lastIdx].classList.remove(actCls);dots.children[bestIdx].classList.add(actCls);lastIdx=bestIdx;
    });
  }
  setupDots(document.querySelector('#pbz .bvd-tr'),document.querySelector('#pbz .bvd-dots'),'bvd-act');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["butterfly-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* FAQ accordion placeholder — no more tabs logic */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catsaur-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* FAQ accordion uses native <details> — no JS needed */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout-custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const backToTop = document.getElementById('BackToTop');
    if (!backToTop) return;
    
    // 滚动显示/隐藏返回顶部按钮
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }, { passive: true });
    
    // 点击返回顶部
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwkbzc-lip-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#plp .pf-item button.pf-q').forEach(function(q){
    q.addEventListener('click',function(){this.parentElement.classList.toggle('op')});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fishalert-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* Event delegation on document so handlers survive re-render */

    /* ---- Testimonial video play ---- */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('#fa-wrap .fa-tst-video .fa-play');
      if(!btn) return;
      var box = btn.closest('.fa-tst-video');
      var video = box.querySelector('video');
      if(!video) return;
      box.classList.add('fa-playing');
      video.setAttribute('controls','controls');
      video.play();
    });

    /* ---- Reviews "show more" ---- */
    document.addEventListener('click', function(e){
      var more = e.target.closest('#fa-wrap #faTstMore');
      if(!more) return;
      e.preventDefault();
      var grid = document.getElementById('faTstGrid');
      if(!grid) return;
      grid.querySelectorAll('.fa-tst-card.fa-tst-hidden').forEach(function(c){ c.classList.remove('fa-tst-hidden'); });
      more.style.display = 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fishyflow-rod-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* Use event delegation on document so handlers work regardless of when
       the section is rendered (theme editor re-renders, lazy injection, etc.) */

    /* ---- FAQ accordions ---- */
    document.addEventListener('click', function(e){
      var q = e.target.closest('#ff-rod-wrap .ff-faq-q');
      if(!q) return;
      var item = q.closest('.ff-faq-item');
      if(!item) return;
      var faqRoot = item.closest('.ff-faq');
      var wasOpen = item.classList.contains('ff-open');
      if(faqRoot){
        faqRoot.querySelectorAll('.ff-faq-item').forEach(function(it){
          it.classList.remove('ff-open');
        });
      }
      if(!wasOpen){
        item.classList.add('ff-open');
      }
    });

    /* ---- Video play ---- */
    document.addEventListener('click', function(e){
      var frame = e.target.closest('#ff-rod-wrap .ff-video-frame');
      if(!frame) return;
      if(frame.querySelector('.ff-video-iframe')) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'ff-video-iframe';
      iframe.src = 'https://player.vimeo.com/video/1168237769?autoplay=1';
      iframe.setAttribute('allow','autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen','');
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });

    /* ---- Reviews "show more" ---- */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('#ff-rod-wrap #ffRevMore');
      if(!btn) return;
      e.preventDefault();
      var grid = document.getElementById('ffRevGrid');
      if(!grid) return;
      grid.querySelectorAll('.ff-rev-card.ff-rev-hidden').forEach(function(c){
        c.classList.remove('ff-rev-hidden');
      });
      btn.style.display = 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexxiled-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pfl .pf-it').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitchen-scissors-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track = document.getElementById('ks-video-track');
  var dotsEl = document.getElementById('ks-video-dots');
  var carousel = document.getElementById('ks-video-carousel');
  var prevArrow = document.getElementById('ks-video-arrow-prev');
  var nextArrow = document.getElementById('ks-video-arrow-next');
  if(!track||!dotsEl||!carousel||!prevArrow||!nextArrow)return;

  var originalItems = Array.from(track.querySelectorAll('.ks-video-item'));
  var totalReal = originalItems.length;
  if(!totalReal)return;

  // Clone all items and append for seamless loop
  originalItems.forEach(function(item){
    var clone = item.cloneNode(true);
    track.appendChild(clone);
  });
  // Clone all again at front for backward loop
  // Track now: [0',1',2', 0,1,2, 0'',1'',2'']
  originalItems.forEach(function(item){
    var clone = item.cloneNode(true);
    track.insertBefore(clone, track.firstChild);
  });

  // After cloning, re-query
  var allItems = track.querySelectorAll('.ks-video-item');
  var total = allItems.length; // = totalReal * 3
  var offset = totalReal; // start index = first real item
  var current = offset;
  var animating = false;
  var stepPx = 0;

  function calcStep(){
    if(allItems[offset]) stepPx = allItems[offset].offsetWidth + 10; // width + gap
  }

  // Build dots — one per real video
  var dotsHtml = '';
  for(var i=0;i<totalReal;i++) dotsHtml += '<button class="ks-video-dot'+(i===0?' active':'')+'" data-index="'+i+'"></button>';
  dotsEl.innerHTML = dotsHtml;
  var dots = dotsEl.querySelectorAll('.ks-video-dot');

  function updateDots(idx){
    var ri = ((idx - offset) % totalReal + totalReal) % totalReal;
    dots.forEach(function(d,i){d.classList.toggle('active',i===ri)});
  }

  function setPosition(idx, animate){
    if(animate===false) track.style.transition = 'none';
    else track.style.transition = 'transform .3s ease';
    track.style.transform = 'translateX(-'+(idx*stepPx)+'px)';
  }

  function afterTransition(idx){
    // If we're on a clone region, jump to the real equivalent
    var newIdx = idx;
    if(idx >= offset + totalReal){
      // We're past the real items on the right (clone region)
      newIdx = idx - totalReal;
    } else if(idx < offset){
      // We're before the real items on the left (clone region)
      newIdx = idx + totalReal;
    }
    if(newIdx !== idx){
      setPosition(newIdx, false);
      // Force reflow so next transition works
      track.offsetHeight;
      track.style.transition = 'transform .3s ease';
      idx = newIdx;
    }
    return idx;
  }

  function goTo(idx){
    if(animating)return;
    if(!stepPx) calcStep();
    if(!stepPx)return;
    animating = true;
    setPosition(idx, true);
    updateDots(idx);
    current = idx;
    setTimeout(function(){
      current = afterTransition(current);
      animating = false;
    }, 330);
  }

  // Init position
  calcStep();
  setPosition(offset, false);

  dotsEl.addEventListener('click',function(e){
    var btn = e.target.closest('button');
    if(!btn)return;
    var dotIdx = parseInt(btn.getAttribute('data-index'));
    if(isNaN(dotIdx))return;
    var target = offset + dotIdx;
    if(target !== current) goTo(target);
  });

  prevArrow.addEventListener('click',function(){goTo(current-1)});
  nextArrow.addEventListener('click',function(){goTo(current+1)});

  // Play/pause via event delegation on track
  track.addEventListener('click',function(e){
    var item = e.target.closest('.ks-video-item');
    if(!item)return;
    // Skip if clicking the play button specifically — it will handle itself
    if(e.target.closest('.ks-video-play'))return;
    var vid = item.querySelector('video');
    if(!vid)return;
    // Pause all
    allItems.forEach(function(it){
      var v = it.querySelector('video');
      if(v && v!==vid){ v.pause(); it.classList.remove('playing'); }
    });
    if(vid.paused){ vid.play(); item.classList.add('playing'); }
    else{ vid.pause(); item.classList.remove('playing'); }
  });

  // Also bind play buttons directly
  allItems.forEach(function(item){
    var btn = item.querySelector('.ks-video-play');
    if(!btn)return;
    btn.addEventListener('click',function(e){
      e.stopPropagation();
      var vid = item.querySelector('video');
      if(!vid)return;
      allItems.forEach(function(it){
        var v = it.querySelector('video');
        if(v && v!==vid){ v.pause(); it.classList.remove('playing'); }
      });
      if(vid.paused){ vid.play(); item.classList.add('playing'); }
      else{ vid.pause(); item.classList.remove('playing'); }
    });
  });

  // Swipe support
  var startX=0,endX=0;
  track.addEventListener('touchstart',function(e){startX=e.touches[0].clientX},{passive:true});
  track.addEventListener('touchend',function(e){
    endX=e.changedTouches[0].clientX;
    var diff=startX-endX;
    if(Math.abs(diff)>40){
      if(diff>0) goTo(current+1);
      else goTo(current-1);
    }
  });

  // Guarantee toggle  
  window.ksToggleGuarantee = function(){
    var g = document.getElementById('ks-guarantee');
    var content = document.getElementById('ks-guarantee-content');
    if(g && content){
      g.classList.toggle('open');
      content.classList.toggle('open');
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kutaye-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#kut-wrap .kp-fq-q').forEach(function(q){
    q.addEventListener('click',function(){this.parentElement.classList.toggle('op')});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelums-eyec-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pec .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelums-masc-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pms .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelums-nad-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pln .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelums-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#plw .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robot-dog-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.getElementById('rd-wrap');
  if(!wrap) return;

  // FAQ accordion: click to toggle, close siblings
  var faqBtns = wrap.querySelectorAll('.rd-faq__q');
  for(var i = 0; i < faqBtns.length; i++){
    faqBtns[i].addEventListener('click', function(e){
      var item = this.parentElement;
      var list = item.parentElement;
      var allItems = list.querySelectorAll('.rd-faq__item');
      for(var j = 0; j < allItems.length; j++){
        if(allItems[j] !== item) allItems[j].classList.remove('open');
      }
      item.classList.toggle('open');
    });
  }

  // Reviews carousel arrows
  var track = document.getElementById('rd-reviews-track');
  var prevBtn = document.getElementById('rd-reviews-prev');
  var nextBtn = document.getElementById('rd-reviews-next');
  if(!track || !prevBtn || !nextBtn) return;

  var cards = track.querySelectorAll('.rd-reviews__card');
  if(!cards.length) return;

  function updateArrows(){
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }

  function scrollBy(amount){
    track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', function(){
    var cardW = cards[0].offsetWidth + 16;
    scrollBy(-cardW);
  });

  nextBtn.addEventListener('click', function(){
    var cardW = cards[0].offsetWidth + 16;
    scrollBy(cardW);
  });

  track.addEventListener('scroll', updateArrows);
  updateArrows();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeleton-tumbler-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ROOT = 'SKLT-wrap';

  function initOnce() {
    var root = document.getElementById(ROOT);
    if (!root || root.dataset.skInit === '1') return;
    root.dataset.skInit = '1';

    // --- Landing gallery scroll (mobile) ---
    var track = root.querySelector('[data-sk-gallery-track]');
    var prevBtn = root.querySelector('[data-sk-gallery-prev]');
    var nextBtn = root.querySelector('[data-sk-gallery-next]');

    function getScrollAmount() {
      if (!track) return 0;
      var firstCard = track.querySelector('.sk-gallery-card');
      if (!firstCard) return track.clientWidth * 0.84;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 14);
      return firstCard.getBoundingClientRect().width + gap;
    }

    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function(){
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function(){
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', function(e){
    if (e.detail && e.detail.sectionId) {
      var root = document.getElementById(ROOT);
      if (root && root.dataset.skInit === '1') {
        root.dataset.skInit = '0';
        initOnce();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartcarry-bag-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* --- Testimonial Carousel (mobile only) --- */
  var grid = document.getElementById('scb-testimonials-grid');
  var dotsContainer = document.getElementById('scb-carousel-dots');
  var prevBtn = document.getElementById('scb-prev-btn');
  var nextBtn = document.getElementById('scb-next-btn');
  if (!grid || !dotsContainer) return;

  var cards = grid.querySelectorAll('.scb-testimonial-card');
  var total = cards.length;
  if (!total) return;

  /* Build dots */
  var dotsHtml = '';
  for (var i = 0; i < total; i++) {
    dotsHtml += '<button class="scb-dot' + (i === 0 ? ' active' : '') + '" data-idx="' + i + '"></button>';
  }
  dotsContainer.innerHTML = dotsHtml;
  var dots = dotsContainer.querySelectorAll('.scb-dot');

  var current = 0;
  var animating = false;

  function setDot(idx) {
    current = idx;
    for (var d = 0; d < dots.length; d++) {
      dots[d].classList.toggle('active', d === idx);
    }
  }

  function goTo(idx) {
    idx = ((idx % total) + total) % total;
    if (idx === current) return;
    current = idx;
    setDot(current);
    animating = true;
    var card = cards[current];
    if (!card) return;
    var target = card.offsetLeft - 15; /* account for padding */
    grid.scrollTo({ left: target, behavior: 'smooth' });
    setTimeout(function() { animating = false; }, 400);
  }

  /* Dot click */
  dotsContainer.addEventListener('click', function(e) {
    var btn = e.target.closest('button');
    if (btn) goTo(parseInt(btn.getAttribute('data-idx')));
  });

  /* Arrow buttons */
  if (prevBtn) {
    prevBtn.addEventListener('click', function() { goTo(current - 1); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() { goTo(current + 1); });
  }

  /* Scroll tracking */
  var scrollTimer;
  grid.addEventListener('scroll', function() {
    if (animating) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      var mid = grid.scrollLeft + grid.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var k = 0; k < total; k++) {
        var dist = Math.abs(cards[k].offsetLeft + cards[k].offsetWidth / 2 - mid);
        if (dist < bestDist) { bestDist = dist; best = k; }
      }
      setDot(best);
    }, 100);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-owl-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* FAQ accordion — event delegation so it survives re-render */
    document.addEventListener('click', function(e){
      var q = e.target.closest('#ow-wrap .ow-faq-q');
      if(!q) return;
      var item = q.closest('.ow-faq-item');
      if(!item) return;
      var faqRoot = item.closest('.ow-faq');
      var wasOpen = item.classList.contains('ow-open');
      if(faqRoot){
        faqRoot.querySelectorAll('.ow-faq-item').forEach(function(it){ it.classList.remove('ow-open'); });
      }
      if(!wasOpen){ item.classList.add('ow-open'); }
    });

    /* Color swatches: relocate into the theme's native variant-selects, hide the
       native option control, and highlight the swatch matching the current ?variant=. */
    function relocateSwatch(){
      var wrap = document.getElementById('owSwatches');
      if(!wrap || wrap.getAttribute('data-moved') === '1') return;
      var vs = document.querySelector('variant-selects, variant-radios, .product-form__input--pill, .product-form__input');
      if(!vs) return; /* native selector not found yet — keep swatch in hero as fallback */
      /* hide the native option controls inside the variant selector */
      vs.querySelectorAll('fieldset, .product-form__input, select, .form__label').forEach(function(el){
        el.style.setProperty('display', 'none', 'important');
      });
      /* move our swatch block into the native selector's parent, right after it */
      var host = vs.parentNode;
      if(host){
        wrap.style.setProperty('margin', '14px 0 0 0', 'important');
        wrap.classList.add('ow-swatches--inline');
        host.insertBefore(wrap, vs.nextSibling);
        wrap.setAttribute('data-moved','1');
      }
    }
    function syncSwatch(){
      var wrap = document.getElementById('owSwatches');
      if(!wrap) return;
      var params = new URLSearchParams(window.location.search);
      var current = params.get('variant');
      var nameEl = document.getElementById('owSwatchName');
      wrap.querySelectorAll('.ow-swatch').forEach(function(s){
        var vid = (s.getAttribute('href') || '').split('variant=')[1];
        var isActive = current ? (vid === current) : s.classList.contains('ow-active');
        s.classList.toggle('ow-active', !!isActive);
        if(isActive && nameEl){ nameEl.textContent = s.getAttribute('data-name') || ''; }
      });
    }
    /* Try relocation now and shortly after (theme may render the selector late) */
    relocateSwatch(); syncSwatch();
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      relocateSwatch(); syncSwatch();
      var w = document.getElementById('owSwatches');
      if((w && w.getAttribute('data-moved') === '1') || tries > 20){ clearInterval(iv); }
    }, 300);

    document.addEventListener('click', function(e){
      var s = e.target.closest('#ow-wrap .ow-swatch, .ow-swatches .ow-swatch');
      if(!s) return;
      var wrap = s.closest('.ow-swatches');
      if(wrap){ wrap.querySelectorAll('.ow-swatch').forEach(function(x){ x.classList.remove('ow-active'); }); }
      s.classList.add('ow-active');
      var nameEl = document.getElementById('owSwatchName');
      if(nameEl){ nameEl.textContent = s.getAttribute('data-name') || ''; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soviren-coat-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ===== IMAGE CAROUSEL ===== */
  var track = document.getElementById('svrn-carousel-track');
  var dotsContainer = document.getElementById('svrn-carousel-dots');
  if (track && dotsContainer) {
    var slides = track.querySelectorAll('.svrn-carousel-slide');
    var totalSlides = slides.length;
    var currentSlide = 0;

    // Build dots
    var dotsHtml = '';
    for (var i = 0; i < totalSlides; i++) {
      dotsHtml += '<button class="svrn-carousel-dot' + (i === 0 ? ' svrn-active' : '') + '" data-idx="' + i + '"></button>';
    }
    dotsContainer.innerHTML = dotsHtml;

    // Auto-scroll detection
    var scrollTimeout;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var slideWidth = track.clientWidth;
        currentSlide = Math.round(track.scrollLeft / slideWidth);
        if (currentSlide >= totalSlides) currentSlide = totalSlides - 1;
        if (currentSlide < 0) currentSlide = 0;
        var dots = dotsContainer.querySelectorAll('.svrn-carousel-dot');
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('svrn-active', parseInt(dots[d].getAttribute('data-idx')) === currentSlide);
        }
      }, 100);
    }, { passive: true });

    // Dot click
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.svrn-carousel-dot');
      if (!dot) return;
      var idx = parseInt(dot.getAttribute('data-idx'));
      var slideWidth = track.clientWidth;
      track.scrollTo({ left: slideWidth * idx, behavior: 'smooth' });
    });
  }

  /* ===== COUNTDOWN TIMER ===== */
  var countdownEl = document.getElementById('svrn-countdown');
  if (countdownEl) {
    var endTime = new Date().getTime() + (24 * 60 * 60 * 1000);
    function updateCountdown() {
      var now = new Date().getTime();
      var dist = endTime - now;
      if (dist > 0) {
        var h = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((dist % (1000 * 60)) / 1000);
        countdownEl.innerHTML = '⏳ Limited-Time Offer · Ends in ' + h + 'h ' + m + 'm ' + s + 's';
      } else {
        countdownEl.innerHTML = '⏳ Offer has ended';
      }
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ===== SCROLL ANIMATION ===== */
  var fadeEls = document.querySelectorAll('#svrn-wrap .svrn-fade-in');
  function checkFade() {
    var windowH = window.innerHeight;
    for (var f = 0; f < fadeEls.length; f++) {
      var rect = fadeEls[f].getBoundingClientRect();
      if (rect.top < windowH - 80) {
        fadeEls[f].classList.add('svrn-visible');
      }
    }
  }
  window.addEventListener('scroll', function() {
    window.requestAnimationFrame(checkFade);
  });
  checkFade();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepprs-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
var r=document.getElementById('spp-page');if(!r)return;
function buildSlider(sliderId,dotsId){
var s=document.getElementById(sliderId);
var t=s?s.querySelector('.spp-slider__track'):null;
var d=document.getElementById(dotsId);
if(!t||!d)return;
var c=t.querySelectorAll('.spp-slider__card,.spp-review-card'),cur=0,total=c.length;
if(!total)return;

var h='';
for(var i=0;i<total;i++)h+='<button class="spp-slider__dot'+(i===0?' active':'')+'" data-idx="'+i+'"></button>';
d.innerHTML=h;
var db=d.querySelectorAll('button');
var cardW=c[0].offsetWidth||210;
var animating=false;

function setDot(n){cur=n;db.forEach(function(x,k){x.classList.toggle('active',k===n)});}
function go(n){
n=((n%total)+total)%total;
if(n===cur){var cc=c[cur];if(cc){t.scrollTo({left:Math.max(0,cc.offsetLeft-(t.clientWidth-cc.offsetWidth)/2),behavior:'smooth'});}return;}
cur=n;setDot(cur);animating=true;
var card=c[cur];if(!card)return;
var target=Math.max(0,card.offsetLeft-(t.clientWidth-card.offsetWidth)/2);
t.scrollTo({left:target,behavior:'smooth'});
setTimeout(function(){animating=false},400);
}

d.addEventListener('click',function(e){var b=e.target.closest('button');if(b)go(parseInt(b.getAttribute('data-idx')));});

var arrows=s.querySelectorAll('.spp-arrow');
for(var a=0;a<arrows.length;a++){arrows[a].addEventListener('click',function(){go(cur+(this.getAttribute('data-dir')==='prev'?-1:1))})}

var st;
t.addEventListener('scroll',function(){
if(animating)return;
clearTimeout(st);
st=setTimeout(function(){
var mid=t.scrollLeft+t.clientWidth/2,b=0,bd=Infinity;
for(var k=0;k<total;k++){var dd=Math.abs(c[k].offsetLeft+c[k].offsetWidth/2-mid);if(dd<bd){bd=dd;b=k}}
cur=b;setDot(b);
},100);
},{passive:true});
}
buildSlider('spp-purpose-slider','spp-purpose-dots');

var vs=document.getElementById('spp-video-slider');
var vsTrack=vs?vs.querySelector('.spp-video__track'):null;
var vsDots=document.getElementById('spp-video-dots');
var vsCards=vsTrack?vsTrack.querySelectorAll('.spp-video__card'):[];
if(vsDots&&vsCards.length){
var vh='',vsCur=0,vsTotal=vsCards.length;
for(var vi=0;vi<vsTotal;vi++)vh+='<button class="spp-slider__dot'+(vi===0?' active':'')+'" data-idx="'+vi+'"></button>';
vsDots.innerHTML=vh;
var vsBtns=vsDots.querySelectorAll('button');
function vsSetDot(n){vsCur=n;vsBtns.forEach(function(d,k){d.classList.toggle('active',k===n)});}
function vsGo(n){n=((n%vsTotal)+vsTotal)%vsTotal;vsSetDot(n);var card=vsCards[n];if(!card)return;var target=Math.max(0,card.offsetLeft-(vsTrack.clientWidth-card.offsetWidth)/2);vsTrack.scrollTo({left:target,behavior:'smooth'});}
vsDots.addEventListener('click',function(e){var b=e.target.closest('button');if(b)vsGo(parseInt(b.getAttribute('data-idx')))});
var vsArrows=vs.querySelectorAll('.spp-arrow');
for(var va=0;va<vsArrows.length;va++){vsArrows[va].addEventListener('click',function(){vsGo(vsCur+(this.getAttribute('data-dir')==='prev'?-1:1))})}
var vsSt;vsTrack.addEventListener('scroll',function(){clearTimeout(vsSt);vsSt=setTimeout(function(){var mid=vsTrack.scrollLeft+vsTrack.clientWidth/2,b=0,bd=Infinity;for(var k=0;k<vsTotal;k++){var dd=Math.abs(vsCards[k].offsetLeft+vsCards[k].offsetWidth/2-mid);if(dd<bd){bd=dd;b=k}}vsCur=b;vsSetDot(b)},100)},{passive:true})}

var rs=document.getElementById('spp-review-slider');
var rsTrack=rs?rs.querySelector('.spp-review__track'):null;
var rsDots=document.getElementById('spp-review-dots');
var rsCards=rsTrack?rsTrack.querySelectorAll('.spp-review__card'):[];
var rsNav=rsDots?rsDots.parentElement:null;
if(rsDots&&rsCards.length){
var rh='',rsCur=0,rsTotal=rsCards.length;
for(var ri=0;ri<rsTotal;ri++)rh+='<button class="spp-review__dot'+(ri===0?' active':'')+'" data-idx="'+ri+'"></button>';
rsDots.innerHTML=rh;
var rsBtns=rsDots.querySelectorAll('button');
function rsSetDot(n){rsCur=n;rsBtns.forEach(function(d,k){d.classList.toggle('active',k===n)});}
function rsGo(n){n=((n%rsTotal)+rsTotal)%rsTotal;rsSetDot(n);var card=rsCards[n];if(!card)return;var target=Math.max(0,card.offsetLeft-(rsTrack.clientWidth-card.offsetWidth)/2);rsTrack.scrollTo({left:target,behavior:'smooth'});}
rsDots.addEventListener('click',function(e){var b=e.target.closest('button');if(b)rsGo(parseInt(b.getAttribute('data-idx')))});
if(rsNav){rsNav.querySelectorAll('.spp-arrow').forEach(function(a){a.addEventListener('click',function(){rsGo(rsCur+(this.getAttribute('data-dir')==='prev'?-1:1))})})}
var rsSt;rsTrack.addEventListener('scroll',function(){clearTimeout(rsSt);rsSt=setTimeout(function(){var mid=rsTrack.scrollLeft+rsTrack.clientWidth/2,b=0,bd=Infinity;for(var k=0;k<rsTotal;k++){var dd=Math.abs(rsCards[k].offsetLeft+rsCards[k].offsetWidth/2-mid);if(dd<bd){bd=dd;b=k}}rsCur=b;rsSetDot(b)},100)},{passive:true})}

var comp=document.getElementById('spp-compare');
if(comp){
var beforeEl=comp.querySelector('.spp-compare__before');
var lineEl=comp.querySelector('.spp-compare__line');
var dragging=false;
function update(pct){
beforeEl.style.width=pct+'%';
lineEl.style.left=pct+'%';
}
comp.addEventListener('mousedown',function(e){dragging=true;e.preventDefault();});
comp.addEventListener('touchstart',function(e){dragging=true;},{passive:true});
document.addEventListener('mousemove',function(e){
if(!dragging)return;
var r=comp.getBoundingClientRect();
var p=Math.max(0,Math.min(100,((e.clientX-r.left)/r.width)*100));
update(p);
});
document.addEventListener('touchmove',function(e){
if(!dragging)return;
var r=comp.getBoundingClientRect();
var p=Math.max(0,Math.min(100,((e.touches[0].clientX-r.left)/r.width)*100));
update(p);
},{passive:true});
document.addEventListener('mouseup',function(){dragging=false;});
document.addEventListener('touchend',function(){dragging=false;});
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tire-repair-kit"] && !Shopify.designMode) return;
  try {
    
(function(){
  var UID='trk-wrap';
  var root=document.getElementById(UID);
  if(!root)return;

  // Gallery dots sync
  var galTr=document.getElementById('trk-gal-tr');
  var galDots=document.getElementById('trk-gal-dots');
  if(galTr&&galDots){
    var slides=galTr.querySelectorAll('.trk-gal-sl');
    var lastIdx=0, nSlides=slides.length;
    for(var i=0;i<nSlides;i++){
      var s=document.createElement('span');
      if(i===0)s.className='trk-act';
      (function(idx){s.addEventListener('click',function(){
        galTr.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'});
      })})(i);
      galDots.appendChild(s);
    }
    galTr.addEventListener('scroll',function(){
      var left=galTr.scrollLeft, mid=left+galTr.clientWidth/2;
      var bestIdx=0, bestDist=Infinity;
      for(var i=0;i<nSlides;i++){
        var d=Math.abs(slides[i].offsetLeft+slides[i].offsetWidth/2-mid);
        if(d<bestDist){bestDist=d;bestIdx=i;}
      }
      if(bestIdx===lastIdx)return;
      galDots.children[lastIdx].classList.remove('trk-act');
      galDots.children[bestIdx].classList.add('trk-act');
      lastIdx=bestIdx;
    });
  }

  // Combo selector
  var combos=document.querySelectorAll('#'+UID+' .trk-combo');
  var qtyInput=document.getElementById('trk-qty');
  combos.forEach(function(c){
    c.addEventListener('click',function(){
      combos.forEach(function(x){x.classList.remove('trk-sel')});
      this.classList.add('trk-sel');
      if(qtyInput)qtyInput.value=this.getAttribute('data-qty');
    });
  });

  // Countdown timer (resets daily at midnight)
  function updateTimer(){
    var now=new Date();
    var end=new Date(now);
    end.setHours(23,59,0,0);
    if(now>end)end.setDate(end.getDate()+1);
    var diff=Math.floor((end-now)/1000);
    var h=Math.floor(diff/3600);
    var m=Math.floor((diff%3600)/60);
    var s=diff%60;
    var he=document.getElementById('trk-h');
    var me=document.getElementById('trk-m');
    var se=document.getElementById('trk-s');
    if(he)he.textContent=String(h).padStart(2,'0');
    if(me)me.textContent=String(m).padStart(2,'0');
    if(se)se.textContent=String(s).padStart(2,'0');
  }
  updateTimer();
  setInterval(updateTimer,1000);

  // Shipping date estimates
  (function(){
    var now=new Date();
    var fmt=function(d){var m=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return m[d.getMonth()]+' '+d.getDate()};
    var shipStart=new Date(now);shipStart.setDate(shipStart.getDate()+1);
    var shipEnd=new Date(now);shipEnd.setDate(shipEnd.getDate()+15);
    var delStart=new Date(now);delStart.setDate(delStart.getDate()+16);
    var delEnd=new Date(now);delEnd.setDate(delEnd.getDate()+21);
    var o=document.getElementById('trk-date-order');
    var s=document.getElementById('trk-date-ship');
    var d=document.getElementById('trk-date-deliver');
    if(o)o.textContent=fmt(now);
    if(s)s.textContent=fmt(shipStart)+' - '+fmt(shipEnd);
    if(d)d.textContent=fmt(delStart)+' - '+fmt(delEnd);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turtle-charm-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function dupTickers(){
    var tickers = document.querySelectorAll('#tlc-wrap .tlc-ticker__track');
    for(var i = 0; i < tickers.length; i++){
      var track = tickers[i];
      var items = Array.prototype.slice.call(track.children);
      for(var j = 0; j < items.length; j++){
        track.appendChild(items[j].cloneNode(true));
      }
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', dupTickers);
  } else {
    dupTickers();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viralaluna-fd-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pfd .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitaliaina-pants-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
var r=document.getElementById('vlp-page');if(!r)return;

function makeCompare(id){
var comp=document.getElementById(id);if(!comp)return;
var beforeEl=comp.querySelector('.vlp-compare__before');
var lineEl=comp.querySelector('.vlp-compare__line');
var dragging=false;
function update(pct){beforeEl.style.width=pct+'%';lineEl.style.left=pct+'%';}
comp.addEventListener('mousedown',function(e){dragging=true;e.preventDefault();});
comp.addEventListener('touchstart',function(e){dragging=true;},{passive:true});
document.addEventListener('mousemove',function(e){
if(!dragging)return;
var rr=comp.getBoundingClientRect();
update(Math.max(0,Math.min(100,((e.clientX-rr.left)/rr.width)*100)));
});
document.addEventListener('touchmove',function(e){
if(!dragging)return;
var rr=comp.getBoundingClientRect();
update(Math.max(0,Math.min(100,((e.touches[0].clientX-rr.left)/rr.width)*100)));
},{passive:true});
document.addEventListener('mouseup',function(){dragging=false;});
document.addEventListener('touchend',function(){dragging=false;});
}
makeCompare('vlp-compare-1');
makeCompare('vlp-compare-2');

var rs=document.getElementById('vlp-review-slider');
var rsTrack=rs?rs.querySelector('.vlp-review__track'):null;
var rsDots=document.getElementById('vlp-review-dots');
var rsCards=rsTrack?rsTrack.querySelectorAll('.vlp-review__card'):[];
var rsNav=rsDots?rsDots.parentElement:null;
if(rsDots&&rsCards.length){
var rh='',rsCur=0,rsTotal=rsCards.length;
for(var ri=0;ri<rsTotal;ri++)rh+='<button class="vlp-review__dot'+(ri===0?' active':'')+'" data-idx="'+ri+'"></button>';
rsDots.innerHTML=rh;
var rsBtns=rsDots.querySelectorAll('button');
function rsSetDot(n){rsCur=n;rsBtns.forEach(function(d,k){d.classList.toggle('active',k===n)});}
function rsGo(n){n=((n%rsTotal)+rsTotal)%rsTotal;rsSetDot(n);var card=rsCards[n];if(!card)return;var target=Math.max(0,card.offsetLeft-(rsTrack.clientWidth-card.offsetWidth)/2);rsTrack.scrollTo({left:target,behavior:'smooth'});}
rsDots.addEventListener('click',function(e){var b=e.target.closest('button');if(b)rsGo(parseInt(b.getAttribute('data-idx')))});
if(rsNav){rsNav.querySelectorAll('.vlp-arrow').forEach(function(a){a.addEventListener('click',function(){rsGo(rsCur+(this.getAttribute('data-dir')==='prev'?-1:1))})})}
var rsSt;rsTrack.addEventListener('scroll',function(){clearTimeout(rsSt);rsSt=setTimeout(function(){var mid=rsTrack.scrollLeft+rsTrack.clientWidth/2,b=0,bd=Infinity;for(var k=0;k<rsTotal;k++){var dd=Math.abs(rsCards[k].offsetLeft+rsCards[k].offsetWidth/2-mid);if(dd<bd){bd=dd;b=k}}rsCur=b;rsSetDot(b)},100)},{passive:true})}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vl-mewing-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pvb .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});

  // Dots: dynamically generated, scroll-sync, click-to-navigate
  function setupDots(track,dots,actCls){
    if(!track||!dots)return;
    var slides=track.children;
    var nSlides=slides.length;
    var lastIdx=0;

    // Generate dots
    dots.innerHTML='';
    for(var i=0;i<nSlides;i++){
      var s=document.createElement('span');
      if(i===0)s.className=actCls;
      (function(idx){s.addEventListener('click',function(){
        track.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'});
      })})(i);
      dots.appendChild(s);
    }

    // Scroll sync - find closest slide
    track.addEventListener('scroll',function(){
      var left=track.scrollLeft;
      var mid=left + track.clientWidth/2;
      var bestIdx=0, bestDist=Infinity;
      for(var i=0;i<nSlides;i++){
        var d=Math.abs(slides[i].offsetLeft + slides[i].offsetWidth/2 - mid);
        if(d<bestDist){bestDist=d;bestIdx=i;}
      }
      if(bestIdx===lastIdx)return;
      dots.children[lastIdx].classList.remove(actCls);
      dots.children[bestIdx].classList.add(actCls);
      lastIdx=bestIdx;
    });
  }

  setupDots(
    document.querySelector('#pvb .pvv-tr'),
    document.querySelector('#pvb .pvv-dots'),
    'pvv-act'
  );
  setupDots(
    document.querySelector('#pvb .pts-g'),
    document.querySelector('#pvb .pts-dots'),
    'pts-act'
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vla-balm-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#pcb .pf-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('op')})});
  function setupDots(track,dots,actCls){
    if(!track||!dots)return;
    var slides=track.children,nSlides=slides.length,lastIdx=0;
    dots.innerHTML='';
    for(var i=0;i<nSlides;i++){
      var s=document.createElement('span');
      if(i===0)s.className=actCls;
      (function(idx){s.addEventListener('click',function(){track.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'})})})(i);
      dots.appendChild(s);
    }
    track.addEventListener('scroll',function(){
      var left=track.scrollLeft,mid=left+track.clientWidth/2;
      var bestIdx=0,bestDist=Infinity;
      for(var i=0;i<nSlides;i++){var d=Math.abs(slides[i].offsetLeft+slides[i].offsetWidth/2-mid);if(d<bestDist){bestDist=d;bestIdx=i}}
      if(bestIdx===lastIdx)return;
      dots.children[lastIdx].classList.remove(actCls);dots.children[bestIdx].classList.add(actCls);lastIdx=bestIdx;
    });
  }
  setupDots(document.querySelector('#pcb .pth-g'),document.querySelector('#pcb .pth-dots'),'pth-act');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltcut-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.getElementById('vc-wrap');
  if(!wrap) return;

  // FAQ Accordion
  var faqItems = wrap.querySelectorAll('.vc-faq-item');
  for(var i=0; i<faqItems.length; i++){
    faqItems[i].addEventListener('click', function(){
      this.classList.toggle('op');
    });
  }

  // Video Carousel Dots
  var vidTrack = document.getElementById('vc-vid-track');
  var vidDots = document.getElementById('vc-vid-dots');
  if(vidTrack && vidDots){
    var slides = vidTrack.children;
    var nSlides = slides.length;
    var lastIdx = 0;

    vidDots.innerHTML = '';
    for(var j=0; j<nSlides; j++){
      var s = document.createElement('span');
      if(j===0) s.className = 'vc-vid-act';
      (function(idx){
        s.addEventListener('click', function(){
          vidTrack.scrollTo({left: slides[idx].offsetLeft, behavior: 'smooth'});
        });
      })(j);
      vidDots.appendChild(s);
    }

    vidTrack.addEventListener('scroll', function(){
      var left = vidTrack.scrollLeft;
      var mid = left + vidTrack.clientWidth / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      for(var k=0; k<nSlides; k++){
        var d = Math.abs(slides[k].offsetLeft + slides[k].offsetWidth/2 - mid);
        if(d < bestDist){ bestDist = d; bestIdx = k; }
      }
      if(bestIdx === lastIdx) return;
      vidDots.children[lastIdx].classList.remove('vc-vid-act');
      vidDots.children[bestIdx].classList.add('vc-vid-act');
      lastIdx = bestIdx;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
